import { Button, Flex, useColorModeValue } from "@chakra-ui/react";
import { EventType } from "@models/event";
import router from "next/router";
import { useMemo } from "react";
const APP_HOST = process.env.NEXT_PUBLIC_HOST || "https://app.moongate.id";
const USER_APP_HOST = process.env.NEXT_PUBLIC_USER_APP_HOST || APP_HOST;

const _t = (key?: string) => key || "";

const CheckoutSuccessButtons = ({
  redirectToAppText,
  redirectToEventText,
  type = EventType.TICKET,
  btnStyle = "full",
}: {
  type?: EventType;
  redirectToAppText?: string;
  redirectToEventText?: string;
  btnStyle?: string;
}) => {
  const href = useMemo(() => {
    if (type === EventType.BENEFIT) return `${USER_APP_HOST}/benefits`;
    return USER_APP_HOST;
  }, [type]);

  const clickEventHandler = () => {
    if (type === EventType.MEMBERSHIP)
      return (window.location.href = `${USER_APP_HOST}/benefits`);
    return router.push(`${window.location.href.replace(/\/checkout.+/, "")}`);
  };

  return (
    <Flex
      direction={{ base: "column", sm: "row" }}
      marginY={8}
      gap={6}
      width={"full"}
      justifyContent={"space-between"}
    >
      {redirectToAppText && (
        <Button
          width={btnStyle}
          textTransform="capitalize"
          color={useColorModeValue("", "white")}
          onClick={() => {
            window.location.href = href;
          }}
        >
          {_t(redirectToAppText)}
        </Button>
      )}
      {redirectToEventText && (
        <Button
          width={btnStyle}
          variant="outline"
          onClick={clickEventHandler}
          color={useColorModeValue("", "white")}
          textTransform="capitalize"
        >
          {_t(redirectToEventText)}
        </Button>
      )}
    </Flex>
  );
};

export default CheckoutSuccessButtons;
